import { api } from "./api";

const purchaseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addPurchase: builder.mutation({
      query: (datas) => ({
        url: "create_purchase",
        method: "POST",
        body: datas,
      }),
      invalidatesTags: ["purchases"],
    }),
    getPurchases: builder.query({
      query: () => "all_purchase",
      providesTags: ["purchases"],
    }),
    getBothPurchase: builder.query({
      query: (purId) => `both_purchase?purId=${purId}`,
      providesTags: ["purchases"],
    }),
    removePurchase: builder.mutation({
      query: (id) => ({
        url: `purchases/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["purchases"],
    }),
    editPurchase: builder.mutation({
      query: (editData) => ({
        url: `purchases`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["purchases"],
    }),
  }),
});

export const {
  useAddPurchaseMutation,
  useGetPurchasesQuery,
  useGetBothPurchaseQuery,
  useRemovePurchaseMutation,
  useEditPurchaseMutation,
} = purchaseApi;
